import React from 'react'

const ToggleButtons = ({
  toggle,
  setToggle,
  trueOption,
  falseOption,
  toggleWidth = '100%',
  btnStyles = { height: '1.5625vw', fontSize: '12px' },
}) => {
  return (
    <div
      className="mx- d-flex justify-content-between align-items-center rounded-1 overflow-hidden"
      style={{ border: '0.5px solid #707070', width: toggleWidth }}
    >
      <div
        className="d-flex justify-content-center align-items-center w-50"
        style={{
          backgroundColor: toggle ? '#000' : '#fff',
          color: toggle ? '#fff' : '#000',
          cursor: 'pointer',
          ...btnStyles,
        }}
        onClick={() => setToggle(true)}
      >
        <p
          style={{
            marginBlock: '0',
            fontWeight: toggle ? '600' : '400',
          }}
        >
          {trueOption}
        </p>
      </div>
      <div
        className="d-flex justify-content-center align-items-center w-50"
        style={{
          color: toggle ? '#000' : '#fff',
          backgroundColor: toggle ? '#fff' : '#000',
          cursor: 'pointer',
          ...btnStyles,
        }}
        onClick={() => setToggle(false)}
      >
        <p
          style={{
            marginBlock: '0',
            fontWeight: toggle ? '400' : '600',
          }}
        >
          {falseOption}
        </p>
      </div>
    </div>
  )
}

export default ToggleButtons
